import type { Ceviri } from "../tip";
import type { bicim as tr } from "../tr/bicim";

/** English dictionary · bicim. */
export const bicim: Ceviri<typeof tr> = {
  yuzde: (govde) => `${govde}%`,
  bilinmiyor: "unknown",
  sinifiBilinmiyor: "class unknown",

  sayiHatasi: {
    EMPTY: "Enter a number.",
    BAD_CHARS: "Use only digits, dots and commas.",
    BAD_GROUPING: "Thousands separators must come in groups of three.",
    AMBIGUOUS: "The decimal separator appears more than once.",
    TOO_MANY_DECIMALS: "At most 12 decimal places can be entered.",
    TOO_LARGE: "The number is too large (at most 18 whole digits).",
    INVALID: "Invalid number.",
  },

  hesapTuru: {
    araci_kurum: "Brokerage",
    banka: "Bank",
    cuzdan: "Wallet",
    borsa: "Exchange",
    fiziki: "Physical",
  },

  hareketTuru: {
    BUY: "Buy",
    SELL: "Sell",
    DIVIDEND: "Dividend",
    INTEREST: "Interest",
    SPLIT: "Split",
    BONUS: "Bonus shares",
    RIGHTS: "Rights issue",
    DEPOSIT: "Deposit",
    WITHDRAWAL: "Withdrawal",
    FEE: "Fee / commission",
    TRANSFER_IN: "Transfer in",
    TRANSFER_OUT: "Transfer out",
    TAX_PAYMENT: "Tax payment",
    FX_CONVERSION: "Currency exchange",
  },
  dovizAlis: "Currency purchase",
  dovizSatis: "Currency sale",

  varlikSinifi: {
    equity_tr: "BIST stock",
    equity_foreign: "Foreign stock",
    etf: "Exchange-traded fund",
    crypto: "Crypto",
    fund_tr: "Mutual fund (TEFAS)",
    commodity: "Precious metal",
    fx: "Currency",
    deposit: "Deposit / interest",
    other: "Other",
  },

  damga: {
    oversold: {
      label: "Sold more than was held",
      action: "The vault may start incomplete: an opening transfer may be missing.",
    },
    transfer_cost_unknown: {
      label: "Transfer cost not entered",
      action: "Cost was NOT counted as zero; the gain stays incomplete for this lot.",
    },
    rescale_without_lots: {
      label: "No lots to distribute",
      action: "A split/bonus arrived while no lot was open. Review the transaction dates.",
    },
    mixed_currency: {
      label: "The asset's lots are in different currencies",
      action: "Cost was converted lot by lot, each at the rate of its own date.",
    },
    nakit_hareketi_okunamadi: {
      label: "Cash line amount could not be read",
      action:
        "Cash transactions are coded as quantity = 1, price = amount; on this line the " +
        "product is zero but the price is not. That account's net flow cannot be " +
        "computed — fix the quantity of the record the stamp points to.",
    },
    nakit_hareketi_cevrilemedi: {
      label: "Cash could not be converted to the report currency",
      action:
        "The net in the bucket's OWN currency is correct and shown; only the rate for " +
        "the requested day is missing. Rate sync will complete this line too.",
    },
    para_birimi_taninmiyor: {
      label: "Currency code not recognised",
      action:
        "The code written in the vault is not in the closed list; no rate can be looked " +
        "up. Fix the code the stamp shows — until then this asset's cost and gain stay " +
        "incomplete.",
    },
    fiyat_yok: {
      label: "No price",
      action: "There is no price up to the requested day. Sync from Tracking or enter a manual price.",
    },
    kur_yok: {
      label: "No exchange rate",
      action: "The value exists in the asset's currency but not in the report currency. A rate sync is needed.",
    },
    elle_deger_yok: {
      label: "No manual value entered",
      action: "This asset has neither a unit price nor a total value. Enter one in Manual valuations.",
    },
    para_birimi_celiskisi: {
      label: "Currency conflict",
      action: "The price currency differs from the transactions'. The asset link may be wrong.",
    },
    elle_fiyat_yoksayildi: {
      label: "Manual price ignored",
      action:
        "This asset is tracked: its daily price comes from the source and is the only one. " +
        "The price you entered was not used; you can delete the record.",
    },
    kapali_pozisyon: {
      label: "Closed position",
      action: "Quantity is zero: nothing to value, realised gain exists.",
    },
    nakit_tutar_okunamadi: {
      label: "Cash line amount could not be read",
      action:
        "A cash line is coded as `quantity = 1, price = amount`; this line has no quantity. " +
        "The amount was NOT guessed — the line was left out of cash flow. Fix the transaction.",
    },
    sermaye_hareketi_haric: {
      label: "Capital movement excluded",
      action: "Deposits and withdrawals are not returns; they were left out of cash flow.",
    },
    maliyet_eksik: {
      label: "Part of the cost is unknown",
      action: "The gain is INCOMPLETE; it was not counted as zero.",
    },
    kaydedilmemis_temettu: {
      label: "Dividend at the source, not in the vault",
      action: "If you received a dividend, enter a DIVIDEND transaction; cash flow and return are short by that much.",
    },
    kaydedilmemis_bolunme: {
      label: "Split at the source, not in the vault",
      action: "Enter a SPLIT transaction: the quantity is pre-split, so the market value may be wrong.",
    },
    bedelsiz_ruchan_bilinmiyor: {
      label: "No source for bonus/rights issues",
      action:
        "Quantity and cost rely only on the BONUS/RIGHTS transactions in the vault. " +
        "If you received bonus shares or a rights issue, enter it.",
    },
  },

  dayanak: {
    fiyat: "cached price",
    "elle-fiyat": "manually entered price",
    "elle-deger": "manually entered total value",
    kur: "exchange rate",
    hareket: "the transaction's own price",
  },

  olcumuyle: (olcum, beklenti) => `as measured ${olcum} · ${beklenti}`,
  guncellemesiBekleniyordu: (an) => `update expected ${an}`,
  bekleniyordu: (gun) => `expected ${gun}`,
  gunBayat: (n) => `${n} ${n === 1 ? "day" : "days"} stale`,
};
